






































import { Vue, Component, Prop } from 'vue-property-decorator';
import type { AuthenticationStep } from '@getaccept/lib-shared/src/authentication/types/authentication-step';
import { AuthenticationStepType } from '@getaccept/lib-shared/src/authentication/types/enums/authentication-step-type';

@Component
export default class QnA extends Vue {
  @Prop() authStep: AuthenticationStep;
  @Prop() submittingResponse: boolean;

  value = '';

  get qnaLabel(): string {
    return this.authStep.data.question || this.$t('password').toString();
  }

  handleAnswer() {
    this.$emit('answer', { type: AuthenticationStepType.VerifyQna, value: this.value });
  }
}
